import { H3, Header, Section, Separator, useMedia } from "@/components";
import ListActionPopover from "@/settings/ListActionPopover";
import { ThemeSettings, useThemeStore } from "@/store";
import { useResolvedTheme } from "@/theme/helpers";

export default function GeneralSettingsScreen() {
  const { lg } = useMedia();
  const { themeChoice, setThemeChoice } = useThemeStore();
  const resolvedTheme = useResolvedTheme();

  return (
    <Section margin="$screenPadding" flex={1} $lg={{ flex: 1, gap: "$250" }}>
      {lg && (
        <Header gap="$250">
          <H3>General</H3>
          <Separator borderColor="$fillNeutral" />
        </Header>
      )}
      <ListActionPopover
        dataTrackingId="theme-selection"
        label="Theme"
        valueText={themeChoice ?? resolvedTheme}
        options={[
          { label: "Light", value: ThemeSettings.Light },
          { label: "Dark", value: ThemeSettings.Dark },
          { label: "System", value: ThemeSettings.System },
        ]}
        onSelect={(value) => setThemeChoice(value as ThemeSettings)}
      />
    </Section>
  );
}
